import { useEffect } from "react";
import { Button, Row, Input, Form } from "antd";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo-lightmode.png";
import { selectAuth, loginAsync } from "../../store/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { selectLang, setLang } from "store/lang/langSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import ErrorMessage from "components/ErrorMessage";
import { t } from "@lingui/macro";
import { languages } from "constants/constants";

interface Values {
  username: string;
  password: string;
}

const initialVal: Values = {
	username: "",
	password: "",
};

export default function Login() {
	const auth = useSelector(selectAuth);
	const lang = useSelector(selectLang);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		if (auth) {
			navigate("/dashboard");
		}
	}, [auth, navigate]);

	const handleChangeLang = (key: string) => {
		dispatch(setLang(key));
	};

	const handleLogin = (dataLogin: Values) => {
		dispatch(loginAsync(dataLogin));
	};

	const formik = useFormik({
		initialValues: initialVal,
		validationSchema: Yup.object({
			username: Yup.string().required(t`Username is required`),
			password: Yup.string().required(t`Password is required`),
		}),
		validateOnBlur: false,
		validateOnChange: false,
		onSubmit(values: Values) {
			handleLogin(values);
		},
	});

	const { values, handleChange, handleSubmit, errors, validateField } = formik;

	return (
		<div className="login flex">
			<div className="block-left h-full w-5/12 hidden md:block bg-center" />
			<div className="block-right h-full relative w-full md:w-7/12">
				<div className="form ">
					<div className="logo">
						<img alt="logo" src={logo} className="object-contain" />
					</div>
					<Form onFinish={handleSubmit}>
						<div className="mb-3 md:mb-5">
							<Input
								name="username"
								placeholder={t`Username`}
								value={values.username}
								onChange={handleChange}
								className="md:h-11"
								onBlur={() => validateField("username")}
							/>
							<ErrorMessage text={errors.username} />
						</div>
						<div className="mb-3 md:mb-5">
							<Input.Password
								name="password"
								placeholder={t`Password`}
								iconRender={visible =>
									visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
								}
								className="md:h-11"
								value={values.password}
								onChange={handleChange}
								onBlur={() => validateField("password")}
							/>
							<ErrorMessage text={errors.password} />
						</div>

						<Row>
							<Button
								type="primary"
								htmlType="submit"
								className="bg-[#1890ff] md:h-11"
							>
								{t`Login`}
							</Button>
						</Row>
					</Form>
				</div>
				<footer className="absolute bottom-5 w-full">
					<div className="flex justify-center">
						{languages.map(el => (
							<span
								key={el.key}
								className={`px-2 text-[#00000073] text-center cursor-pointer ${
									el.key === lang ? "font-bold" : "font-normal"
								}`}
								onClick={() => handleChangeLang(el.key)}
							>
								{el.name}
							</span>
						))}
					</div>
					<div className="text-[#00000073] text-center mt-5">Liberty @2022</div>
				</footer>
			</div>
		</div>
	);
}
